import { Component, EventEmitter, Output } from '@angular/core';
import { DataQueryDto } from '../../shared/dto/data-query.dto';

@Component({
  selector: 'wl-reports-query-tool-date-param-dialog',
  templateUrl: './reports-query-tool-date-param-dialog.component.html',
  styleUrls: ['./reports-query-tool-date-param-dialog.component.less'],
    standalone: false
})
export class ReportsQueryToolDateParamDialogComponent {
  showDatePrompt: boolean = false;
  currentQuery: DataQueryDto;
  @Output() onDateChanged = new EventEmitter<DataQueryDto>();

  openDialog(currentQuery: DataQueryDto) {
    this.currentQuery = currentQuery;
    this.showDatePrompt = true;
    currentQuery.DateParameters.forEach((element) => {
      element.Value = new Date(element.Value);
    });
  }

  acceptDateParams() {
    this.onDateChanged.emit(this.currentQuery);
    this.cancel();
  }

  cancel() {
    this.showDatePrompt = false;
  }
}
